import { render, staticRenderFns } from "./Topics.vue?vue&type=template&id=2e926112"
import script from "./Topics.vue?vue&type=script&lang=ts"
export * from "./Topics.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports